var _desc, _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 6") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "0.538314431 0.215 7.4614837 0.215 7.4614837 7.13808557 0.538314431 7.13808557"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Desktop-Event-Details-TPP",
    transform: "translate(-375.000000, -543.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    transform: "translate(376.000000, 544.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(3.000000, 3.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.0745,1.9169 L2.1785,0.3539 C2.1205,0.2509 2.0025,0.1969 1.8875,0.2199 L1.1255,0.3719 C0.9675,0.4009 0.8355,0.5099 0.7765,0.6599 C0.2005,2.1589 0.6785,4.1209 2.1095,5.5559 C2.1115,5.5579 2.1185,5.5649 2.1205,5.5669 C3.5545,6.9979 5.5175,7.4759 7.0165,6.8999 C7.1665,6.8409 7.2745,6.7089 7.3045,6.5519 L7.4565,5.7899 C7.4785,5.6739 7.4265,5.5569 7.3235,5.4979 L5.7605,4.6019 C5.6525,4.5399 5.5165,4.5579 5.4285,4.6459 C5.1355,4.9379 4.5095,5.5639 4.5085,5.5639 C3.9465,5.3859 3.4355,5.0739 3.0215,4.6539 C2.6025,4.2399 2.2905,3.7299 2.1125,3.1679 C2.1125,3.1679 2.7375,2.5409 3.0315,2.2479 C3.1185,2.1599 3.1365,2.0239 3.0745,1.9169",
    id: "Fill-1",
    fill: "#979797",
    mask: "url(#mask-2)"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#979797",
    cx: 7,
    cy: 7,
    r: 7
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/Phone.95fc949ecd97ba33c7e7520b15d95824.svg";
export { ForwardRef as ReactComponent };